// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1RG65","footer":"ModalError_footer__1CF8q"};